import * as React from "react";
import { filterSingleValue } from "../../../../api_calls/TableauVisuals";
import NoSortMultiSelect from "../../../../components/commonComponents/Selectors/NoSortMultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { checkUserRole } from "../../../../api_calls/userManagement";
import { updateStateData } from "../../../../Store/actions";

export default function AnalysisGroup({ redux_param_name, multiSelect, reduxKeywordToSaveValue }) {
  const userStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [changesMade, setChangesMade] = React.useState(false);
  const [selectedAnalysisGroup, setAnalysisGroup] = React.useState([]);
  const [selectedAnalysisGroupName, setAnalysisGroupName] = React.useState([]);
  const [dataLoaded, setDataLoaded] = React.useState(false);

  const userRole = userStateData?.brand_report_view === true ? { user_role: "Brand" } : checkUserRole();
  let adlevelNames =
    typeof userStateData.adlevel_names !== "undefined" && userStateData.adlevel_names.length !== 0
      ? [
        ...userStateData.adlevel_names.map((adlevelInfo) => {
          return adlevelInfo.label;
        }),
      ]
      : [];

  if (userRole.user_role === "Brand") {
    // check brand filter object to fetch stores for brand (selected by retailer)
    adlevelNames = userStateData?.brand_filters?.performance_filter?.analysis_group
      ? multiSelect
        ? [...userStateData.brand_filters.performance_filter.analysis_group]
        : [...userStateData.brand_filters.performance_filter.analysis_group].filter((item) => item !== "(All)")
      : [];
  }



  React.useEffect(() => {
    setAnalysisGroup(adlevelNames);

    // selected values for analysis group
    const selectedValues = typeof userStateData[reduxKeywordToSaveValue] !== "undefined" && typeof userStateData[reduxKeywordToSaveValue][redux_param_name] !== "undefined" ? userStateData[reduxKeywordToSaveValue][redux_param_name] : adlevelNames

    if (selectedValues.length !== 0) {
      setAnalysisGroupName(
        selectedValues.map((groupName) => {
          return { value: groupName, label: groupName };
        })
      );
    }

    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
  }, []);

  return dataLoaded ? (
    <NoSortMultiSelect
      enableFullWidth={true}
      enableSearch={true}
      label={"Analysis Groups"}
      options={adlevelNames.map((groupName) => {
        return { value: groupName, label: groupName };
      })}
      defaultVal={selectedAnalysisGroupName}
      selectionCheck={(option, value) => option.label === value.label}
      usedFor="AnalysisGroup"
      onChangeCall={(selectedOption) => {
        let userChoices = [];
        selectedOption.forEach((chosen) => {
          if (chosen.label !== "(All)") {
            userChoices.push(chosen.label);
          } else {
            userChoices.push([...new Set(adlevelNames)]);
          }
        });
        setAnalysisGroup(userChoices);
        setAnalysisGroupName(selectedOption);
        setChangesMade(true);
      }}
      onBlurCall={(e) => {
        if (selectedAnalysisGroup.length !== 0 && changesMade === true) {
          let adlevelSelections = selectedAnalysisGroup;
          dispatchAction(
            updateStateData({
              [reduxKeywordToSaveValue]: {
                ...userStateData[reduxKeywordToSaveValue],
                [redux_param_name]: adlevelSelections,
              },
            })
          );
          setChangesMade(false);
        }
      }}
    />
  ) : (
    <></>
  );
}
